import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ItemType, ListItemSnippetType } from '../../components/lists/list-item-snippet.component';

export enum DialogType {
  danger = 'danger',
  success = 'success',
  info = 'info',
  warning = 'warning',
}

export interface DialogData {
  title: string;
  hint: string;
  yes: string;
  no: string;
  type: DialogType;
  itemState: string;
  clusterCat: boolean;
  item?: ListItemSnippetType;
  itemType?: ItemType;
  hideSnippet?: boolean;
}

@Component({
  selector: 'dialog-template',
  template: `
    <div class="dialog confirm alert alert-danger text-center">
      <div *ngIf="data.clusterCat" class="clustercat-holding">
        <svg class="clustercat-holding-head">
          <use href="#img-sprite_clustercat-holding-head"></use>
        </svg>
        <svg class="clustercat-holding-hand right">
          <use href="#img-sprite_clustercat-holding-hand"></use>
        </svg>
        <svg class="clustercat-holding-hand left">
          <use href="#img-sprite_clustercat-holding-hand"></use>
        </svg>
      </div>
      <div class="dialog-text">
        <h3>{{ data.title }}</h3>
        <p [innerHTML]="data.hint"></p>
        <list-item-snippet *ngIf="!data.hideSnippet" [itemType]="data.itemType" [item]="data.item"></list-item-snippet>
      </div>
      <div class="dialog-btn-container">
        <button class="btn btn-lg btn-default dialog-button" (click)="cancel()">{{ data.no }}</button>
        <button
          class="btn btn-lg dialog-button"
          [ngClass]="{
            'btn-danger': data.type === 'danger',
            'btn-warning': data.type === 'warning',
            'btn-info': data.type === 'info',
            'btn-success': data.type === 'success'
          }"
          (click)="confirm()"
        >
          {{ data.yes }}
        </button>
      </div>
      <div class="dialog-close" (click)="cancel()"></div>
    </div>
  `,
})
export class DialogTemplateComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<DialogTemplateComponent>,
  ) {}

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
